import React from "react";
import { NewDynamicTab } from "../../../components/Page";
import { JvvnlOverviewMetric } from "../../../config/DefaultDates";
import { JvvnlTitle, TabSwitcher } from "../Jvnnl_Dashboard";
import JvvnlMetric from "./JvvnlMetric";

const Metric = () => {
  return (
    <NewDynamicTab
      headerPrefixComponent={<TabSwitcher />}
      defaultDates={JvvnlOverviewMetric}
      header="Net Load & DRE Flow"
      showTabs={false}
      middleComponent={<JvvnlTitle />}
      tabs={{
        Metric: <JvvnlMetric />,
      }}
    />
  );
};

export default Metric;
